'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

require('../../../primitives/Button/Button.js');

require('../../../primitives/Hero/Hero.js');

var Icon = require('../../../primitives/Icon/Icon.js');

require('../../../primitives/Link/Link.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var handleSearch = function handleSearch(e) {
  if (e.key === 'Enter') {
    window.location.replace("https://searcher-green.lanl.gov/webapps/LANL_External#/search?q=".concat(encodeURIComponent(e.target.value)));
  }
};

var SearchBlock = function SearchBlock(props) {
  var className = props.className,
      dividerBottom = props.dividerBottom,
      dividerTop = props.dividerTop,
      title = props.title;
  var classes = index['default']('search-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-search-bar"
  }, /*#__PURE__*/React__default['default'].createElement("h3", {
    className: "sidebar-header"
  }, "SEARCH ", title), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "input-group search-group"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "input-group-prepend"
  }, /*#__PURE__*/React__default['default'].createElement(Icon.Icon, {
    icon: "search",
    className: "search-icon"
  })), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "text",
    placeholder: "Search",
    className: "search-input",
    onKeyDown: handleSearch
  })));
};

SearchBlock.defaultProps = {
  dividerBottom: false,
  dividerTop: true
};
SearchBlock.propTypes = {
  className: PropTypes__default['default'].string,
  dividerBottom: PropTypes__default['default'].bool,
  dividerTop: PropTypes__default['default'].bool,
  title: PropTypes__default['default'].string
};
exports.SearchBlock = SearchBlock;
exports['default'] = SearchBlock;